import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useCurrentUser } from '@/lib/auth-context';
import { canAccessPath, homeRouteFor } from '@/lib/role-access';

/**
 * Centralized layout-route guard. For every authenticated render under
 * AppShell, looks up the current pathname in `ROUTE_ACCESS` and either
 * passes through (`<Outlet />`) or redirects.
 *
 * Single source of truth: the same `canAccessPath()` powers Sidebar
 * visibility, so a user never sees a link that this guard would then
 * reject.
 */
export const RouteGuard = () => {
  const user = useCurrentUser();
  const location = useLocation();

  if (canAccessPath(user, location.pathname)) {
    return <Outlet />;
  }

  // If the role-home would loop back here, send to /forbidden instead.
  const target = homeRouteFor(user);
  if (target === location.pathname) {
    return <Navigate to="/forbidden" replace />;
  }
  return <Navigate to={target} replace state={{ from: location }} />;
};

export default RouteGuard;
